module.exports = __webpack_public_path__ + "img/convert-currency.96b641a2.png";